import Dexie, { Table } from 'dexie';
import { PedidoTemp } from 'src/app/model/pedidoTemp';



export class AppDB extends Dexie {

  detallePedidoBD!: Table<PedidoTemp>;

  constructor() {
    super("pedido");
    this.version(3).stores({detallePedidoBD:'++id'});
 //   this.on('populate', () => this.populate());
  }

  
}

export const db = new AppDB();